import api from './api';

export const getUsers = (params = {}) => api.get('/admin/users', { params });
export const updateUser = (id, data) => api.put(`/admin/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/admin/users/${id}`);
export const getCategories = () => api.get('/categories');
export const createCategory = (data) => api.post('/admin/categories', data);
export const updateCategory = (id, data) => api.put(`/admin/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`/admin/categories/${id}`);
export const createAchievement = (data) => api.post('/admin/achievements', data);
export const getLearningPaths = () => api.get('/admin/learning-paths');
export const createLearningPath = (data) => api.post('/admin/learning-paths', data);
export const updateLearningPath = (id, data) => api.put(`/admin/learning-paths/${id}`, data);
export const deleteLearningPath = (id) => api.delete(`/admin/learning-paths/${id}`);